import { Link } from "react-router-dom";
import moment from "moment"
import { useState } from "react";
import DatePicker from 'react-datepicker'
import { useForm, Controller } from 'react-hook-form'
import 'react-datepicker/dist/react-datepicker.css'; // Import the CSS
import { format } from 'date-fns';
function AppointmentMap({ ts, tsIndex, onUpdate, isEditing, setIsEditing, formData }) {
    console.log('form', ts)
    const {
        control,
        register,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm()
    const currentDate = new Date();
    const [selectedDate, setSelectedDate] = useState();
    const [dateTimeSlots, setDateTimeSlots] = useState(formData?.timeSlot)
    const [formTimeSlotsFiltered, setFormTimeSlotsFiltered] = useState([])
    const [loading, setloading] = useState(false);
    const [genderId, setGenderId] = useState(ts?.gender_id)

    const checkInput = (e) => {
        // const onlyDigits = e.target.value.replace(/\D/g, '')
        //
        const onlyDigits = e.target.value

        setNumber(onlyDigits)
        if (!number) {
            // let number1 = '+9715' + onlyDigits
            let number1 = onlyDigits
            setPhone(number1)
        } else {
            let number1 = onlyDigits
            setPhone(number1)
        }
    }
    const [phone, setNumber] = useState('')
    const [number, setPhone] = useState('')

    const [editValue, setEditValue] = useState(ts);
    const handleEditChange = (e) => {
        setEditValue(e?.target?.value);
    };
    const handleChange = (date) => {
        const formattedDate = date ? format(date, 'yyyy-MM-dd') : '';
        const timeSlots = dateTimeSlots?.filter(dateTimeAndSlots => dateTimeAndSlots?.date === formattedDate);
        setFormTimeSlotsFiltered(timeSlots)
        setSelectedDate(formattedDate)
    };
    const onSubmit = (data) => {
        let formData = new FormData();
        // formData.append('name', data?.name)
        // formData.append('email', data?.email)
        // formData.append('phone', '+44' + data?.phone.replace(/^0+/g, ''))
        formData.append('date', selectedDate)
        formData.append('gender_id', data?.gender_id)
        formData.append('category_id', data?.category_id)
        formData.append('slot_id', data?.slot_id)
        formData.append('id', ts?.id)
        formData.append('is_confirm', 'yes')
        onUpdate(formData)

    };

    const handleCancel = () => {
        setEditValue(ts); // Revert to original value
        setIsEditing(false);
    };


    return <>
        <tr className="color-theme" key={tsIndex + 1} >
            <td colSpan={9} className="td-style">
                <span style={{ color: 'Purple' }}>Appointment </span>
                {moment(ts?.timeslot?.date).format("DD MMMM, YYYY")}  ({moment(ts?.timeslot?.start_time, "HH:mm").format("h:mm A")})
            </td>
        </tr>
        <tr key={tsIndex + 1} className="text-center-line" style={{ fontSize: '50px !important' }}>
            <td>{tsIndex + 1}</td>
            {/* <td>{ts?.timeslot?.start_time}</td> */}
            <td>{ts?.name}</td>
            <td>{ts?.email}</td>
            <td>{ts?.phone}</td>
            <td>{ts?.gender?.title}</td>
            <td>{ts?.category?.title}</td>
            <td>{ts?.is_confirm}</td>
            <td>{moment(ts?.created_at).format(" DD MMMM,YYYY  hh:mm A")}</td>
            <td>
                {isEditing === ts?.id ? (
                    <><i style={{ color: "blue" }} onClick={() => setIsEditing(ts?.id)} class="far fa-edit fa-lg"></i></>
                ) : (
                    <i style={{ color: "blue" }} onClick={() => setIsEditing(ts?.id)} class="far fa-edit fa-lg"></i>
                )}
                {/* &nbsp;&nbsp;&nbsp;&nbsp;
                                <a
                                  style={{ color: "red" }}
                                  onClick={() => destroyTag(ts.id)}
                                >
                                  <i class="fas fa-trash-alt fa-lg"></i>
                                </a> */}
            </td>


        </tr>
        <tr key={tsIndex + 1} className="text-center-line" style={{ fontSize: '50px !important' }}>

            {isEditing === ts.id ? (
                // Render input field when editing
                <td colSpan={8}>
                    <div>
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            id="appointmentForm"
                            action="#"
                            method="POST"
                            data-toggle="validator"
                            className="wow fadeInUp"
                        >
                            <div className="row">
                                <div className="form-group col-md-3 mb-2">
                                    <input
                                        type="text"
                                        name="name"
                                        className="form-control"
                                        id="name"
                                        placeholder="First Name"
                                        readOnly
                                        value={ts?.name}
                                        {...register('name', { required: false })}

                                    />
                                    {errors.name && errors.name.type === 'required' && (
                                        <span className="error-color">
                                            This field is required.
                                        </span>
                                    )}
                                    <div className="help-block with-errors" />
                                </div>
                                <div className="form-group col-md-3 mb-2">
                                    <input
                                        type="email"
                                        name="email"
                                        className="form-control"
                                        id="email"
                                        readOnly
                                        value={ts?.email}
                                        placeholder="Email Address"
                                        {...register('email', {
                                            required: false, pattern: {
                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, // Regular expression for email
                                                message: "Please enter a valid email address" // Error message for pattern mismatch
                                            }
                                        })}
                                    />
                                    {errors.email && errors.email.type === 'required' && (
                                        <span className="error-color">
                                            This field is required.
                                        </span>
                                    )}
                                    {errors?.email && (
                                        <span className="error-color">
                                            {errors?.email?.message}
                                        </span>
                                    )}
                                    <div className="help-block with-errors" />
                                </div>
                                <div className="form-group col-md-3 mb-2" >
                                    <input
                                        id="phone"
                                        className="form-control"
                                        type="tel"
                                        name='phone'
                                        placeholder="Format 07 12346789"
                                        minLength="11"
                                        maxLength="11"
                                        inputmode="numeric"
                                        readOnly
                                        {...register('phone', {
                                            required: false,
                                            minLength: {
                                                value: 11,
                                                message:
                                                    'Phone No must be minimum 11 characters',
                                            },
                                            maxLength: {
                                                value: 11,
                                                message:
                                                    'Phone No must be maximum 11 characters',
                                            },
                                            pattern: {
                                                value: /^07\d{9}$/,
                                                message: (
                                                    "Invalid Format. Please Start With 07 Instead"
                                                ),
                                            },
                                        })}

                                        value={number ? number : phone ? phone : ts?.phone?.replace("+44", "0")}
                                        onChange={(e) => {
                                            checkInput(e)
                                        }}
                                    />

                                    {errors?.phone && errors?.phone?.type === 'required' && (
                                        <span className="error-color">
                                            This field is required.
                                        </span>
                                    )}

                                    {errors?.phone && (
                                        <span className="error-color">
                                            {errors?.phone?.message}
                                        </span>
                                    )}
                                    <div className="help-block with-errors" />
                                </div>
                                <div className="form-group col-md-3 mb-2">
                                    <Controller
                                        control={control}
                                        className="form-control"
                                        name="gender_id"
                                        rules={{ required: "gender is required" }} // Add validation rules
                                        render={({ field }) => (
                                            <select
                                                name="gender_id"
                                                className="form-control form-select"
                                                id="gender_id"
                                                {...register('gender_id', { required: true })}
                                                onChange={(gender_id) => field.onChange(gender_id)}
                                                value={field?.value ? field?.value : ts?.gender_id}

                                            >
                                                <option value={''}>
                                                    Select Gender
                                                </option>
                                                {formData?.gender?.map((gender, index) => {
                                                    return <>
                                                        <option value={gender?.id}>{gender?.title}</option>
                                                    </>
                                                })}
                                            </select>
                                        )}
                                    />

                                    {errors.gender_id && errors.gender_id.type === 'required' && (
                                        <span className="error-color">
                                            This field is required.
                                        </span>
                                    )}

                                    <div className="help-block with-errors" />
                                </div>
                                <div className="form-group col-md-3 mb-2">
                                    <Controller
                                        control={control}
                                        className="form-control"
                                        name="category_id"
                                        rules={{ required: "Category is required" }} // Add validation rules
                                        render={({ field }) => (
                                            <select
                                                name="category_id"
                                                className="form-control form-select"
                                                id="category_id"
                                                {...register('category_id', { required: true })}
                                                onChange={(category_id) => field.onChange(category_id)}
                                                value={field?.value ? field?.value : ts?.category_id}

                                            >
                                                <option value={''}>
                                                    Select Category
                                                </option>
                                                {formData?.category?.map((category, index) => {
                                                    return <>
                                                        <option value={category?.id}>{category?.title}</option>
                                                    </>
                                                })}
                                            </select>
                                        )}
                                    />
                                    {errors.category_id && errors.category_id.type === 'required' && (
                                        <span className="error-color">
                                            This field is required.
                                        </span>
                                    )}
                                    <div className="help-block with-errors" />
                                </div>


                                <div className="form-group col-md-3 mb-2">
                                    <Controller
                                        control={control}
                                        className="form-control form-select"
                                        name="date"
                                        rules={{ required: "Date is required" }} // Add validation rules
                                        render={({ field }) => (
                                            <DatePicker
                                                id="date"
                                                placeholderText="Select Date"
                                                onChange={(date) => {
                                                    field?.onChange(date);// Pass the date to RHF's onChange
                                                    handleChange(date);// Pass the date to custom onChange
                                                }}
                                                selected={field?.value} // RHF's value
                                                dateFormat="dd-MMM-yyyy" // Display format for the user
                                                // minDate={currentDate} // Set the minimum selectable date to today
                                                popperClassName="example-datepicker-class"
                                                showIcon={true}
                                                value={field?.value ? field?.value : ts?.date}
                                            />
                                        )}
                                    />
                                    {errors.date && errors.date.type === 'required' && (
                                        <span className="error-color" style={{ fontSize: '12px' }}>
                                            Select New* Date & Time before Update*
                                        </span>
                                    )}
                                    <div className="help-block with-errors" />
                                </div>
                                <div className="form-group col-md-3 mb-2" >
                                    <Controller
                                        control={control}
                                        className="form-control"
                                        name="slot_id"
                                        rules={{ required: "Time is required" }} // Add validation rules
                                        render={({ field }) => (
                                            <select
                                                name="slot_id"
                                                className="form-control form-select"
                                                id="slot_id"
                                                {...register('slot_id', { required: true })}
                                                value={field?.value}

                                            >
                                                <option value="" disabled="" selected="">
                                                    {moment(ts?.timeslot?.start_time, "HH:mm").format("h:mm A")}
                                                </option>
                                                {formTimeSlotsFiltered?.map((timeSlot, index) => {
                                                    return <>
                                                        <option style={{ fontWeight: 800 }} value={timeSlot?.id}> {moment(timeSlot?.start_time, "HH:mm").format("h:mm A")}</option>
                                                    </>
                                                })}
                                            </select>
                                        )}
                                    />

                                    {errors.slot_id && errors.slot_id.type === 'required' && (
                                        <span className="error-color" style={{ fontSize: '12px' }}>
                                            Select Time Update.
                                        </span>
                                    )}
                                    <div className="help-block with-errors" />
                                </div>

                                <div className="col-lg-1">
                                    <div className="contact-form-btn">
                                        <button type="submit" className="btn btn-danger" disabled={loading}>
                                            Update
                                        </button>
                                        {loading && <img src={'/loader.gif'} width={'30px'} height={'30px'} />}
                                    </div>
                                </div>
                                <div className="col-lg-1">
                                    <div className="contact-form-btn">
                                        <button className="btn btn-submit" onClick={handleCancel}>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </td>

            ) : (
                <></>
            )}
        </tr>

    </>
}

export default AppointmentMap